interface PriceLineProps {
  label: string
  value: string
  variant?: 'default' | 'discount' | 'total'
  className?: string
}

export function PriceLine({ label, value, variant = 'default', className = '' }: PriceLineProps) {
  if (variant === 'total') {
    return (
      <div className={`flex items-center justify-between font-semibold text-lg ${className}`}>
        <span>{label}</span>
        <span>{value}</span>
      </div>
    )
  }

  if (variant === 'discount') {
    return (
      <div className={`flex items-center justify-between text-sm text-primary ${className}`}>
        <span>{label}</span>
        <span>{value}</span>
      </div>
    )
  }

  return (
    <div className={`flex items-center justify-between text-sm ${className}`}>
      <span className="text-muted-foreground">{label}</span>
      <span>{value}</span>
    </div>
  )
}
